export default __webpack_public_path__ + "static/anim150-a09cf8eaa1642ee5ba0584ed55909236.gif";